module.exports = __webpack_public_path__ + "static/media/2.bcd8ee24.png";